
  <!-- MAIN (Center website) -->
  <head><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
  <div class="header">
    <div class="logo header-content"></div>
    <ul class="user-actions header-content">
      <li ><a routerLink="/login">Sign in </a></li>
      
    </ul>
  </div>
  <div class="nav">
    <ul class="nav-options">
      <li>Our Product</li>
      <li>Plans</li>
      <li>Help</li>
      <li>Contact</li>
    </ul>
  </div> <br><br>
  <h3 align="Center">Set your New Password</h3>
<div class="page-container">

<form #userForm="ngForm" >

<input  name="usereid" [(ngModel)]='user.email_id' type="text" #usereid="ngModel" class="form-control" readonly  required>

<input ng required type="password" [(ngModel)]=user.password0 name="password0" #password0="ngModel" class="form-control" placeholder="Password">


<input type="password" required [(ngModel)]=user.password #password="ngModel" name="password" class="form-control" placeholder="Confirm Password">
<div class="alert alert-danger" *ngIf="password.touched && !password.valid">
<img  src="assets/images/icon-alert.png" >
Confirm Password</div>

<div class="alert alert-danger" *ngIf="password0.touched && userForm.value.password !== userForm.value.password0 ">
  <img  src="assets/images/icon-alert.png" >
  Password mismatch</div>

<button type="button" [disabled]="!userForm.valid" (click)="setUserPass()" routerLink="../login"  class="btn primary-btn" name="submit" >Submit</button>

    
</form>
</div>





